/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { conditionallyCreateMapObjectLiteral } from '@angular/compiler/src/render3/view/util';
import { AbstractControl, FormControl } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

/**
 *
 * @param control Control that has the validatior defined
 * @param form Complete form
 * @param options A validation function specific option object. Example:
 * @returns true if validation passed. An object with the validation id and a message property
 *  inside if failed. Example: { "date": { message: "Something went wrong"}}
 */


export function maxRelatedInputValidator(
  control: AbstractControl,
  form: FormlyFieldConfig,options: any = {},
) {
  const model = control.value;
  let errormsg = '';
  const keyname = form.key as string;
  let keynameFrom: any;
  let keynameTo: any;
  if (!model || !form.model) {
    return null;
  }
  for (const [key, value] of Object.entries(form.model)) {
    if(key.includes('SequenceNumber') || key.includes('From')){
      keynameFrom = value ;
    }else if(key.includes('NumberOfBuildings') || key.includes('To')){
      keynameTo = value;
    }
  }
  if(keyname && (keyname.includes('SequenceNumber') || keyname.includes('From'))){
    keynameFrom = control.value;
  }else if(keyname && (keyname.includes('NumberOfBuildings') || keyname.includes('To'))){
    keynameTo = control.value;
  }
  if(keynameFrom && keynameTo && (keynameFrom > keynameTo)){
    errormsg =  "Value should be Lesser than "+ keynameTo;
  }
  if(errormsg){
    return {
      relatedInputValidation: {
        message: errormsg,
      }
    };
  }else{
    return null;
    }
}


